import { useMutation } from "@tanstack/react-query";
import axios from "axios";

interface ResetPasswordParams {
  userName: string;
  realm: string;
  templateLanguage: string; 
}

export const useSendResetPassword = () => {
  const sendResetPasswordMail = async (data: ResetPasswordParams) => {
    try {
      await axios.post(
        "/users/sendResetPasswordMail",
        {
          userIdentifier: data.userName,
          realm: data.realm,
          templateLanguage: data.templateLanguage, 
        },
        {
          baseURL: process.env.REACT_APP_INPUT_CORE,
        }
      );
    } catch (error) {
      console.error("Error sending reset password email:", error);
      throw error;
    }
  };

  return useMutation<void, Error, ResetPasswordParams>(sendResetPasswordMail);
};